import WebAnalyticsDashboard from "../WebAnalytics/WebAnalyticsDashboard"

const ShareDashboardWeb = () => {
  return <WebAnalyticsDashboard isPublic={true} />
}

export default ShareDashboardWeb
